<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">资产负债表</span>
			<span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
      <Button color="normal" @click="exportToExcel" :loading="loading" style="margin-left: 20px;">导出 Excel</Button>
		</div>
		<div class="h-panel-body">
			<table class="balance" v-if="!showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2">科目编码</td>
					<td rowspan="2">科目名称</td>
					<td colspan="2">期初余额</td>
<!--					<td colspan="2">本期发生额</td>-->
					<td colspan="2">期末余额</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
<!--					<td>借方</td>-->
<!--					<td>贷方</td>-->
				</tr>
				</thead>
        <tbody>
        <!-- 遍历数据列表，生成表格行 -->
        <tr v-for="item in dataList" :key="item.subjecId">
          <!-- 科目编码列，根据层级设置缩进 -->
          <td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
          <!-- 科目名称列，根据层级设置缩进并添加hover效果 -->
          <td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
          <!-- 期初借方余额列，右对齐并格式化数字 -->
          <td align="right">{{item.beginningDebitBalance|numFormat}}</td>
          <!-- 期初贷方余额列，右对齐并格式化数字 -->
          <td align="right">{{item.beginningCreditBalance|numFormat}}</td>
          <!-- 本期借方发生额列，右对齐并格式化数字 -->
<!--          <td align="right">{{item.currentDebitAmount|numFormat}}</td>-->
<!--          &lt;!&ndash; 本期贷方发生额列，右对齐并格式化数字 &ndash;&gt;-->
<!--          <td align="right">{{item.currentCreditAmount|numFormat}}</td>-->
          <!-- 期末借方余额列，右对齐并格式化数字，负数时添加tip样式 -->
          <td :class="{tip:item.endingDebitBalance<0}" align="right">{{item.endingDebitBalance|numFormat}}</td>
          <!-- 期末贷方余额列，右对齐并格式化数字，负数时添加tip样式 -->
          <td :class="{tip:item.endingCreditBalance<0}" align="right">{{item.endingCreditBalance|numFormat}}</td>
        </tr>
        <!-- 数据列表为空时显示暂无数据提示 -->
        <tr v-if="!dataList.length">
          <td colspan="8" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
 import * as XLSX from "xlsx";
 import moment from "moment";

 /**
	 * 新资产负债表
	 */
	export default {
		name: "XinZiChanFuZhai",
		data() {
			return {
				dataList: [],
				accountDate: null,
				showNumPrice: false,
				loading: false,
        subjectName: {
          '1001': '库存现金',
          '1002': '银行存款',
          '1003': '应收账款',
          '1004': '其他应收款',
          '100401': '押金',
          '100402': '借款',
          '100403': '装修款',
          '100404': '员工社保费',
          '1005': '库存商品',
          '1006': '低值易耗品',
          '1007': '原材料',
          '1008': '固定资产',
          '1009': '累计折旧',
          '1010': '待摊费用',
          '1011': '投资损失',
          '2001': '应付账款',
          '2002': '应付职工薪酬',
          '2003': '其他应付款',
          '2004': '预提费用',
          '2005': '递延收益',
          '2006': '顾客定金',
          '2007': '顾客欠货',
        },
        codeList: [
          '1001',
          '1002',
          '1003',
          '1004',
          '100401',
          '100402',
          '100403',
          '100404',
          '1005',
          '1006',
          '1007',
          '1008',
          '1009',
          '1010',
          '1011',
          '2001',
          '2002',
          '2003',
          '2004',
          '2005',
          '2006',
          '2007',
        ]
			}
		},
		watch: {
			accountDate() {
				this.loadList();
			},
			showNumPrice() {
				this.loadList();
			}
		},
		methods: {

      /**
       * 导出 Excel
       */
      exportToExcel() {
        if (this.dataList.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        this.loading = true;

        try {
          // 准备导出数据
          const exportData = this.dataList.map((item, index) => ({
            '序号': index + 1,
            '科目编码': item.code,
            '科目名称': item.name,
            '期初借方余额': item.beginningDebitBalance !== null ? item.beginningDebitBalance : '',
            '期初贷方余额': item.beginningCreditBalance !== null ? item.beginningCreditBalance : '',
            '期末借方余额': item.endingDebitBalance !== null ? item.endingDebitBalance : '',
            '期末贷方余额': item.endingCreditBalance !== null ? item.endingCreditBalance : ''
          }));
          // 创建 worksheet
          const worksheet = XLSX.utils.json_to_sheet(exportData);

          // 设置列宽
          const colWidths = [
            { wch: 8 },  // 序号
            { wch: 15 }, // 科目编码
            { wch: 20 }, // 科目名称
            { wch: 15 }, // 期初借方余额
            { wch: 15 }, // 期初贷方余额
            { wch: 15 }, // 期末借方余额
            { wch: 15 }  // 期末贷方余额
          ];
          worksheet['!cols'] = colWidths;
          // 创建工作簿
          const workbook = XLSX.utils.book_new();

          // 获取当前日期作为文件名的一部分
          const fileNameDate = this.accountDate ? moment(this.accountDate).format('YYYY-MM') : moment().format('YYYY-MM');
          const fileName = `资产负债表_${fileNameDate}.xlsx`;

          XLSX.utils.book_append_sheet(workbook, worksheet, '资产负债表');

          // 导出文件
          XLSX.writeFile(workbook, fileName);

          this.$Message.success(`数据导出成功，文件名：${fileName}`);
        } catch (error) {
          console.error('导出失败:', error);
          this.$Message.error('导出失败，请重试');
        } finally {
          this.loading = false;
        }
      },

			loadList() {
				this.loading = true;
				this.$api.accountbook.loadSubjectBalance2({
					accountDate: this.accountDate,
					showNumPrice: this.showNumPrice
				}).then(({data}) => {

					// this.dataList = data;
          // console.log("data JSON格式:", JSON.stringify(data, null, 2));
          this.dataList = data.filter(item => this.codeList.includes(item.code));
          // 查找 name 为"合计"的记录
          const totalRecord = data.find(item => item.name === '合计');
          // 如果找到合计记录，添加到过滤后的数据末尾
          if (totalRecord) {
                this.dataList = [...this.dataList, totalRecord];
          }
          //创建 data 的 map，方便查找
          // const dataMap = new Map();
          // data.forEach(item => {
          //   dataMap.set(item.code, item);
          // });
          // 确保 subjectName 中的所有科目都显示
          // this.dataList = Object.keys(this.subjectName).map(code => {
          //   if (dataMap.has(code)) {
          //     return dataMap.get(code);
          //   } else {
          //     // 如果 data 中没有该科目，创建一个默认对象（余额为 0）
          //     return {
          //       subjecId: code,
          //       code: code,
          //       name: this.subjectName[code],
          //       beginningDebitBalance: 0,
          //       beginningCreditBalance: 0,
          //       currentDebitAmount: 0,
          //       currentCreditAmount: 0,
          //       endingDebitBalance: 0,
          //       endingCreditBalance: 0
          //     };
          //   }
          // });
					this.loading = false;
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.h-panel-bar {
		display: flex; /* 使用 Flexbox 布局 */
		justify-content: space-between; /* 让子元素两端对齐 */
		align-items: center; /* 垂直居中对齐 */
	}
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
